import { useUserPermissions } from "@hooks/userUserPermission";
import { AnalysisUserType } from "@models/platform-analysis/entities/analysis";
import { RootState } from "@redux/store";
import { isNil } from "lodash";
import { memo } from "react";
import { useSelector } from "react-redux";
import { AnalysisSummaryStepSectionRenderConfigs } from "../../configs";

interface SummaryRenderSectionContainerProps {
  isReview: boolean;
  disabled?: boolean;
  isReadOnly?: boolean;
}

export const SummaryRenderSectionContainer = memo(
  ({ disabled, isReview, isReadOnly }: SummaryRenderSectionContainerProps) => {
    const { isSupplierGroup } = useUserPermissions();
    const userType: AnalysisUserType = isSupplierGroup ? "supplier" : "adviser";

    const storedSummaryData = useSelector(
      (state: RootState) => state.platformAnalysis.platformAnalysis?.summary,
    );
    const storedPortfolioLevel = useSelector(
      (state: RootState) => state.platformAnalysis?.ui?.portfolioLevel,
    );

    if (!storedSummaryData) return null;

    return (
      <>
        {AnalysisSummaryStepSectionRenderConfigs.map((config, configIndex) => {
          const {
            showFor,
            Component: RenderComponent,
            dependencyField,
          } = config;

          if (!showFor.includes(userType) || isNil(RenderComponent))
            return null;
          if (dependencyField && !storedSummaryData[dependencyField])
            return null;

          return (
            <RenderComponent
              key={configIndex}
              disabled={disabled}
              isReadOnly={isReadOnly}
              userType={userType}
              isReview={isReview}
              portfolioLevel={storedPortfolioLevel}
              {...config}
            />
          );
        })}
      </>
    );
  },
);
